import { Popup } from '@paywithextend/components'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import {
  selectDeletingUserFromState,
  selectTopLevelErrorFromState,
} from 'src/app/ProfileDelete/redux/profileDelete.selectors'
import AppName from 'src/components/AppName/AppName'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import { useTranslate } from 'src/localization/Trns'
import { createSetIsDeleteAccountPopupOpen } from 'src/redux/actions/app.actions'
import { deleteUser } from 'src/redux/actions/data/users.actions'
import { css } from 'styled-components'

const DeleteAccountPopup: React.FC = (): React.ReactElement => {
  const translate = useTranslate()

  const dispatch = useDispatch()
  const deletingUser = useSelector(selectDeletingUserFromState)
  const topLevelError = useSelector(selectTopLevelErrorFromState)
  const { analytics } = useAnalyticsContext()

  const warningMessage = translate(
    'Warning: Once your account is deleted you will be logged out and no longer have access to your ${appName} account.',
    {
      appName: <AppName />,
    },
  )
  const dispatchDeleteUserThenSignout = (): void => {
    dispatch(deleteUser(analytics))
  }

  const closePopup = (): void => {
    dispatch(createSetIsDeleteAccountPopupOpen(false))
  }

  return (
    <Popup
      onClickClose={closePopup}
      showCloseButton
      css={css`
        display: flex;
        flex-direction: column;
        position: relative;
      `}
    >
      <ConfirmationPopupContent
        title={translate('Delete Your Profile')}
        subtitle={warningMessage}
        actionButtonLabel={translate('Yes, permanently delete account')}
        actionButtonOnClick={dispatchDeleteUserThenSignout}
        actionButtonLoading={deletingUser}
        actionButtonVariant="severe"
        topLevelError={topLevelError}
        cancelButtonOnClick={closePopup}
        cancelButtonVariant="secondary"
        cancelButtonLabel={translate('Cancel')}
      />
    </Popup>
  )
}

export default DeleteAccountPopup
